export default {
  props: {
    lander: { type: Object, default: () => ({}) },
  },
};
